export const TOOLBAR_CONFIG = {
  editBase: {
    path: '/service-base/site-management/edit',
    query: { step: 'base' },
    name: 'editBase'
  },
  editSites: {
    path: '/service-base/site-management/edit',
    query: { step: 'site' },
    name: 'editSite'
  },
  createBase: {
    path: '/service-base/site-management/create',
    query: { step: 'base' },
    name: 'createBase'
  },
  createSites: {
    path: '/service-base/site-management/create',
    query: { step: 'site' },
    name: 'createSite'
  },
  mapping: {
    path: '/service-base/mapping',
    name: 'mapping',
    component: 'service-base'
  },
  siteManagement: {
    path: '/service-base/site-management',
    name: 'siteManagement',
    component: 'service-base'
  },
  rentalsHistory: {
    path: '/rentals/history',
    name: 'history'
  },
  rentalsAppointemnt: {
    path: '/rentals/appointment',
    name: 'appointemnt'
  },
  rentals: {
    path: '/rentals',
    name: 'allRentals'
  },
  addNewBike: {
    path: '/bikes/create',
    name: 'addNewBike',
    component: 'add-new-bike'
  },
  bikeInfoEdit: {
    path: '/bikes/:id/edit',
    name: 'bikeInfoEdit'
  },
  bikeInfo: {
    path: '/bikes/:id',
    name: 'bikeInfo',
    component: 'bike-info',
    back: ''
  },
  bikeManagement: {
    path: '/bikes',
    name: 'bikeManagement',
    component: 'bike-management'
  },
  accessories: {
    path: '/maintenance/accessories',
    name: 'accessories',
    component: 'accessories',
    back: '/maintenance'
  },
  waiting: {
    path: '/maintenance/waiting',
    name: 'waiting',
    back: ''
  },
  repairing: {
    path: '/maintenance/repairing',
    name: 'repairing',
    back: ''
  },
  detecting: {
    path: '/maintenance/detecting',
    name: 'detecting',
    back: ''
  },
  malfunction: {
    path: '/maintenance/malfunction',
    name: 'malfunction',
    back: ''
  },
  maintenance: {
    path: '/maintenance/maintenance',
    name: 'maintenance',
    back: ''
  },
  userInfoEdit: {
    path: '/members/:id/edit',
    name: 'editUser',
    back: ''
  },
  userInfo: {
    path: '/members/:id',
    name: 'userInfo',
    component: 'user-info',
    back: ''
  },
  addUser: {
    path: '/members/create',
    name: 'addUser'
  },
  userManagement: {
    path: '/members',
    name: 'userManagement',
    component: 'user-management'
  },
  analytics: {
    path: '/analytics',
    name: 'analytics'
  }
}

const fetchConfig = (route) => {
  for (const configKey in TOOLBAR_CONFIG) {
    const config = TOOLBAR_CONFIG[configKey]
    if (matchRoute({ config, route })) return config
    continue
  }
  return null
}

const matchRoute = ({ config, route }) => {
  if (config.query) {
    const queryMatched = checkQuery({ config, route })
    if (!queryMatched) return
  }

  const RULES = [
    checkMatched,
    checkPath
  ]

  for (const rule of RULES) {
    const result = rule({ config, route })
    if (result) return true
  }
  return false
}

const checkQuery = ({ config, route }) => {
  const { query: queryRule } = config
  const { query } = route
  for (const key in queryRule) {
    if (query[key] === queryRule[key]) return true
  }
  return false
}

const checkMatched = ({ config, route }) => {
  const { path: pathRule } = config
  const { matched } = route
  for (const matchRule of matched) {
    if (matchRule.path === pathRule) return true
  }
  return false
}

const checkPath = ({ config, route }) => {
  const { path: pathRule } = config
  return route.path.startsWith(pathRule)
}

export {
  fetchConfig
}
